<template>
  <div class="flex justify-center align-items-center my-2">
    <template v-if="!isBoost">
      <p class="mr-1 text-sm text-gray-500">Powered by</p>
      <img src="@/assets/logo.svg" class="pt-0 w-[72px] h-[26px]" />
    </template>
    <img v-if="isBoost" src="@/assets/boost-powered-by.svg" class="w-[100px]" />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const isBoost = computed(() => router.currentRoute.value.fullPath.includes('boost'));
</script>
